import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md w-full bg-white shadow-lg rounded-xl p-8 text-center">
        <div className="text-6xl font-extrabold text-gray-300">404</div>
        <h1 className="mt-2 text-2xl font-bold text-gray-900">Página não encontrada</h1>
        <p className="mt-2 text-gray-600">
          A página que você procura não existe ou foi movida.
        </p>
        <div className="mt-6 flex gap-3 justify-center">
          <Link
            to="/dashboard"
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          >
            Ir para o Dashboard
          </Link>
          <Link
            to="/login"
            className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
          >
            Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;


